import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { ProjectEntityDTO, SubstitutionDTO } from '../../api/plyca-dtos-v2';
import { Component, OnInit, Optional, ElementRef, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormConfig, TemplateDef } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';

import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DatePipe } from '@angular/common';
import { UserService } from '../../user.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { DaciExtDTO } from './daciExtDTO';
import { DaciExtService } from './daciExt.service';


// templateUrl: 'customField.edition.template.html'
@Component({
  selector: 'daciExt-edition',
  templateUrl: './daciExt.edition.template.html',
  providers: [DatePipe]
})
export class DaciExtEditionComponent
  extends BaseFormComponent<DaciExtDTO, DaciExtDTO>
  implements OnInit {
  private identifier: string;
  private dossierID: string;
  private readOnly: boolean;

  constructor(
    elem: ElementRef,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    private datePipe: DatePipe,
    private userService: UserService,
    private daciService: DaciExtService,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    this.windowHash = generateRandomIdentifier();
    this.identifier = dialogConfig['id'];
    this.readOnly = dialogConfig['readOnly'];
    this.dossierID = dialogConfig['dossierID'];

  }

  getObjectParams(): { [param: string]: string | string[]; } {
    return {
      projectId: this.dossierID
    };
  }

  getFormSettingURL(): string {
    return './daciExt/daciExt.json';
  }

  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'daciexts/';

  }

  getObjectIdentifier(): string {
    return this.identifier ? this.identifier : 'new';
  }

  dtoToModel(dto: DaciExtDTO): Observable<DaciExtDTO> {

    return of(dto);
  }

  isNew() {
    return this.getObjectIdentifier() === 'new' ? true : false;
  }

  modelToDTO(model: DaciExtDTO): DaciExtDTO {
    return model;
  }

  getTitle(model: DaciExtDTO): string {
    if (model) {
      return model.identifier;
    } else {
      return 'Nuevo grupo';
    }
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Substitution.title';
    headerInfo.titleIcon = 'fas fa-people-carry';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {

    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.searchTags = ['DACI_EXT'];
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readOnly;



    return of(formConfig);
  }





  initHeaderActions() {

    /*this.headerActionsService.clearWindowActions(this.windowHash);

    if (!this.readOnly) {
      this.subscribe(this.headerActionsService.addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),
        () => {
          let daci: DaciExtDTO;
          this.subscribe(this.daciService.new(this.dossierID),
            (result) => {
              if (result) {

                for (let prop in result) {
                  if (result.hasOwnProperty(prop)) {
                    this.model[prop] = result[prop];
                  }
                }
                this.subscribe(this.save(),
                  (resultSave) => {
                    this.ref.close();
                  }
                );
              }
            }
          );
        });
    }*/

    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.readOnly) {
      this.subscribe(this.headerActionsService.addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),
        () => {
          this.subscribe(this.save(),
            (resultSave) => {
              this.ref.close();
            }
          );
        }
      );
    }
  }



}
